import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    primary: "#BD0711",
    secondary: "#273E47",
    accent: "#BD632F"
  }
});
